import { CTA } from '@websrc/App/Components/CTA'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapFooter } from '@websrc/DataMappers/mapFooter'
import React from 'react'

import Heading from '../../Heading/Heading'
import { footerCTA } from './FooterCTA.css'
export type FooterCTAProps = {
  cta: ReturnType<typeof mapFooter>['cta'] | null
}

export const FooterCTA = ({ cta }: FooterCTAProps) => {
  if (!cta || cta.disable_cta_footer) return null

  return (
    <div className={'container-coral-spot'}>
      <div className={footerCTA._}>
        <div className={footerCTA.mainText._}>
          <Heading description={cta.description} headline={cta.headline} level={2} size={'xl'} />
          <div className={footerCTA.mainText.buttens._}>
            {cta.buttons &&
              cta.buttons.map((button, i) => {
                return (
                  <CTA
                    className={footerCTA.mainText.button._}
                    colorTheme={'blue'}
                    cta={{
                      __ctaType: 'internal',
                      newTab: false,
                      text: button.button_link?.title ?? '',
                      url: button.button_link?.href ?? '',
                    }}
                    fontWeight={'bold'}
                    key={i}
                    onClick={() => {
                      matomo.trackEvent(
                        'engagement',
                        'all',
                        [cta.headline],
                        [button.button_link?.title ?? `CTA button ${i}`],
                        'button'
                      )
                    }}
                    type={'primary'}
                  />
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}
